import { Component, Input } from '@angular/core';
import { BaseField } from '../../baseField';
import { ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
declare let $: any;

@Component({
  selector: 'app-creditcard',
  templateUrl: './creditcard.component.html',
  styleUrls: ['./creditcard.component.scss'],
})
export class CreditcardComponent extends BaseField {
  @ViewChild('ccNumber') ccNumberField: ElementRef;
  @Input() cardTypeFormRef: FormControl;
  @Input() cardErrors: string;
  cardtype: string = 'fa-credit-card';
  maxlength: number = 19;
  partitions: Array<number> = [4, 4, 4, 4];
  timeOut:NodeJS.Timeout;

  constructor() {
    super();
  }
  fieldLogicWork() {
    this.creditCardNumberSpacing();
  }
  trimmCardField() {
    return this.formControlRef.value.replace(/\s+/g, '');
  }

  creditCardNumberSpacing() {
    this.cardErrors = '';
    const input = this.ccNumberField.nativeElement;
    const { selectionStart } = input;

    let trimmedCardNum = this.trimmCardField();

    if (trimmedCardNum.length > 16) {
      trimmedCardNum = trimmedCardNum.substr(0, 16);
    }

    /* Handle American Express 4-6-5 spacing */
    let result = this.determineCardType(trimmedCardNum);
    this.cardTypeFormRef.patchValue(result);
    this.mapTypeToClass(result);

    const numbers = [];
    let position = 0;
    this.partitions.forEach((partition) => {
      const part = trimmedCardNum.substr(position, partition);
      if (part) numbers.push(part);
      position += partition;
    });

    this.formControlRef.setValue(numbers.join(' '));

    /* Handle caret position if user edits the number later */
    if (selectionStart < this.formControlRef.value.length - 1) {
      input.setSelectionRange(selectionStart, selectionStart, 'none');
    }

    var card_number = '';
    card_number += $('#card-number').val();
    $('.credit-card-box .number').html(card_number);
  }

  determineCardType(check: string): string {
    let frontVisaLogo = document.getElementById('visa-front');
    let backVisaLogo = document.getElementById('visa-back');
    let frontMasterCardLogo = document.getElementById('master-front');
    let backMasterCardLogo = document.getElementById('master-back');
    if (check.match(/^(34|37)/)) {
      this.maxlength = 17;
      this.partitions = [4, 6, 5];
      return 'American Express';
    } else if (check.match(/^4/)) {
      frontVisaLogo.classList.remove('d-none');
      backVisaLogo.classList.remove('d-none');
      frontMasterCardLogo.classList.add('d-none');
      backMasterCardLogo.classList.add('d-none');
      this.maxlength = 19;
      this.partitions = [4, 4, 4, 4];
      return 'Visa';
    } else if (check.match(/^5[0-5]/)) {
      frontMasterCardLogo.classList.remove('d-none');
      backMasterCardLogo.classList.remove('d-none');
      frontVisaLogo.classList.add('d-none');
      backVisaLogo.classList.add('d-none');
      this.maxlength = 19;
      this.partitions = [4, 4, 4, 4];
      return 'MasterCard';
    } else if (check.match(/^(6011|622|64[4-9]|65)/)) {
      this.maxlength = 19;
      this.partitions = [4, 4, 4, 4];
      return 'Discover';
    } else {
      this.maxlength = 19;
      this.partitions = [4, 4, 4, 4];
      return '';
    }
  }
  mapTypeToClass(type: string): void {
    switch (type) {
      case 'American Express':
        this.cardtype = 'fa-cc-amex';
        break;
      case 'Visa':
        this.cardtype = 'fa-cc-visa';
        break;
      case 'MasterCard':
        this.cardtype = 'fa-cc-mastercard';
        break;
      case 'Discover':
        this.cardtype = 'fa-cc-discover';
        break;
      default:
        this.cardtype = 'fa-credit-card';
        break;
    }
  }
}
